package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_05_03_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just engaged 4 Hezrou warriors in a subterranean stronghold, while Tuesday and Caper rush back, reluctantly hoping to descend into the darkness to aid their endangered comrades.  The heroes battle bravely. Dirk is able to turn the tides of battle by distracting one of the Herzou with a real banger of a joke. As the heroes defeat each Herzou, they turn into demon ichor (to the disappointment of the ravenously hungry Bigglesworth). Tuesday and Caper are able to catch up with the others and assist them in finishing off these foul creatures.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes are exhausted after the battle and return to surface to rest.")
    }
}
